import { useEffect, useState } from "react";
import {
  motion,
  useReducedMotion,
  useScroll,
  useSpring,
  useTransform,
} from "framer-motion";

/**
 * Petit glyphe marque (logo Aëlvir) qui suit le scroll à droite.
 * Décoratif uniquement — masqué < lg, respecte prefers-reduced-motion.
 */
export const ScrollMascot = () => {
  const reduce = useReducedMotion();
  const [visible, setVisible] = useState(false);
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, {
    stiffness: reduce ? 200 : 55,
    damping: reduce ? 40 : 22,
    restDelta: 0.001,
  });
  const top = useTransform(smooth, [0, 1], reduce ? ["42%", "42%"] : ["14%", "72%"]);
  const opacity = useTransform(
    smooth,
    [0, 0.04, 0.08, 0.9, 0.97, 1],
    [0, 0, 0.55, 0.55, 0.2, 0]
  );

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 220);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <motion.div
      aria-hidden
      data-testid="scroll-mascot"
      style={{ top, opacity }}
      className="pointer-events-none fixed right-3 z-[30] hidden w-11 xl:right-5 xl:w-12 lg:block"
    >
      <span className="relative block">
        <img
          src="/images/portal-halo.webp"
          alt=""
          className="absolute inset-[-28%] h-[156%] w-[156%] max-w-none object-contain opacity-45"
          draggable={false}
        />
        <img
          src="/images/aelvir_mark.webp"
          alt=""
          className="relative h-auto w-full drop-shadow-[0_4px_14px_rgba(0,0,0,0.45)]"
          draggable={false}
        />
      </span>
    </motion.div>
  );
};
